import { Factory } from 'rosie';
import { PolicyContextType } from '../PolicyContext';

export const PolicyContextFactory = new Factory<PolicyContextType>().attrs({
  details: {
    region: 'US-MA',
    timeZone: 'America/New_York',
    effectiveDate: '2020-07-07',
    filingIdentifier: 'sone-uuid',
    configDiscoveryParams: 'some base64-encoded string',
    isPolicyDraft: false,
    draftType: undefined,
    isRenewalDraft: false,
    termId: 'termId-uuid',
    mailingState: 'MA',
    showDriverCfrs: false,
    askForUserReportedLicenseStatus: false,
    showMilitarySection: true,
    showStudentSection: true,
    showEducation: true,
    showOccupation: true,
    showRegisteredToApplicantOrSpouse: true,
    showExcludedDriverGender: false,
    showExcludedDriverMaritalStatus: false,
    showPricingData: true,
  },
  person: {
    name: 'Bobby Jones',
  },
  flags: {
    renewalQuotesEnabled: false,
    mandatedDownPay: false,
    isFailingUnderwriting: false,
  },
  canEndorseDuringRegionalEvents: true,
  isEndorseablePolicy: true,
  systemOfRecord: 'clearcover',
  resourceEffectiveGrants: [],
  refetchHandler: () => () => {},
  loading: false,
  productSegment: 'standardAuto',
  draftList: [],
  removeDraft: () => {},
  setDriverOptions: () => {},
  driverOptions: null,
});
